// extracted by mini-css-extract-plugin
export default {"root":"app-portainer-components-ViewLoading-ViewLoading-module__root","message":"app-portainer-components-ViewLoading-ViewLoading-module__message"};